var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_1971",
    "data-name": "\\uADF8\\uB8F9 1971",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2615",
    "data-name": "\\uC0AC\\uAC01\\uD615 2615",
    width: 20,
    height: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1163",
    "data-name": "\\uD328\\uC2A4 1163",
    d: "M-2273.242,102.737c.137-.129.274-.254.405-.384q4.111-4.11,8.219-8.223a1.453,1.453,0,0,1,1.325-.536,1.3,1.3,0,0,1,.835,2.1,4.027,4.027,0,0,1-.389.417q-4.566,4.57-9.136,9.141c-.935.935-1.579.939-2.507.015-1.227-1.22-2.46-2.434-3.675-3.665a1.326,1.326,0,0,1-.175-1.712,1.308,1.308,0,0,1,1.617-.436,2.329,2.329,0,0,1,.611.469c.925.909,1.84,1.829,2.759,2.745A1.044,1.044,0,0,0-2273.242,102.737Z",
    transform: "translate(2280.576 -89.574)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCheckboxChecked);
export default __webpack_public_path__ + "static/media/black_checkbox_checked.00b010fb131d68d2049f85175d970679.svg";
export { ForwardRef as ReactComponent };